import React from "react";
import { useContent } from "../../content/ContentContext";

export const Testimonials = () => {
  const c = useContent("testimonials");
  const items = Array.isArray(c.items) ? c.items : [];
  return (
    <section id="testimonials" data-testid="testimonials-section" className="sc-section">
      <div className="sc-container">
        <div className="max-w-3xl">
          <span className="sc-eyebrow">{c.eyebrow}</span>
          <h2 className="sc-h2 mt-3" data-testid="testimonials-heading">{c.heading}</h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-7">
          {items.slice(0, 3).map((t, i) => (
            <figure key={i} className="sc-card flex flex-col" data-testid={`testimonial-${i}`}>
              <span aria-hidden="true" className="font-serif text-5xl md:text-6xl text-gold/80 leading-none -mt-1">“</span>
              <blockquote className="mt-3 text-ink2 italic font-serif text-[1.2rem] md:text-[1.35rem] leading-[1.55]">
                {t.quote}
              </blockquote>
              <figcaption className="mt-7 pt-5 border-t border-blush-200/70">
                <p className="font-serif text-[1.2rem] md:text-[1.3rem] text-ink leading-tight">{t.name}</p>
                <p className="text-[12px] uppercase tracking-[0.18em] text-muteink mt-1.5 font-semibold font-body">
                  {t.role} · {t.org}
                </p>
              </figcaption>
            </figure>
          ))}
        </div>

        {c.orgs_line && (
          <p className="mt-12 text-center sc-body max-w-3xl mx-auto">{c.orgs_line}</p>
        )}
      </div>
    </section>
  );
};

export default Testimonials;
